import { type RouteObject } from 'react-router'

import { PROFILE_URL } from 'features/profile/paths'
import { lazyComponent } from 'routes/lazy-route'

export const profileRoutes: RouteObject[] = [
  {
    path: PROFILE_URL,
    lazy: lazyComponent(
      () => import('features/profile/Container'),
      'ProfileContainer',
    ),
    handle: { featureKey: PROFILE_URL },
  },
]
